import {
  checkProvidedW9FormFailure,
  checkProvidedW9FormRequest,
  checkProvidedW9FormSuccess,
  getReferralPartnerByIdFailure,
  getReferralPartnerByIdRequest,
  getReferralPartnerByIdSuccess,
  getReferralPartnersFailure,
  getReferralPartnersRequest,
  getReferralPartnersSuccess,
  getStatusEmailSentW9FormFailure,
  getStatusEmailSentW9FormRequest,
  getStatusEmailSentW9FormSuccess,
  removeReferralPartnerFailure,
  removeReferralPartnerRequest,
  removeReferralPartnerSuccess,
  sendEmailW9FormFailure,
  sendEmailW9FormRequest,
  sendEmailW9FormSuccess,
  updateReferralPartnerFailure,
  updateReferralPartnerRequest,
  updateReferralPartnerSuccess,
} from "./referralPartnerSlice";
import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  checkProvidedW9Form,
  getReferralPartnerById,
  getReferralPartners,
  getStatusEmailSentW9Form,
  removeReferralPartner,
  sendEmailW9Form,
  updateReferralPartner,
} from "./referralPartnerApi";
import { handleErrorSaga } from "../../utils/helper";

function* handleGetReferralPartners({ payload }) {
  try {
    const res = yield call(getReferralPartners, payload);
    yield put(getReferralPartnersSuccess(res.data));
  } catch (error) {
    yield put(getReferralPartnersFailure());
    yield handleErrorSaga(error);
  }
}

function* handleGetReferralPartnerById({ payload }) {
  try {
    const res = yield call(getReferralPartnerById, payload);
    yield put(getReferralPartnerByIdSuccess(res.data));
  } catch (error) {
    yield put(getReferralPartnerByIdFailure());
    yield handleErrorSaga(error);
  }
}

function* handleUpdateReferralPartner({ payload }) {
  try {
    const res = yield call(updateReferralPartner, payload);
    yield put(updateReferralPartnerSuccess(res.data));
  } catch (error) {
    yield put(updateReferralPartnerFailure());
    yield handleErrorSaga(error);
  }
}

function* handleRemoveReferralPartner({ payload }) {
  try {
    yield call(removeReferralPartner, payload._id);

    const temp = yield select(
      (state) => state.referralPartnersState.listReferralPartner
    );
    let data = [...temp];
    const index = data.findIndex((item) => item._id === payload._id);
    index >= 0 && data.splice(index, 1);

    yield put(removeReferralPartnerSuccess([...data]));
  } catch (error) {
    yield put(removeReferralPartnerFailure());
    yield handleErrorSaga(error);
  }
}

function* handlegetStatusEmailSentW9FormW9Form({ payload }) {
  try {
    const res = yield call(getStatusEmailSentW9Form, payload);
    yield put(getStatusEmailSentW9FormSuccess(res.data));
  } catch (error) {
    yield put(getStatusEmailSentW9FormFailure());
    yield handleErrorSaga(error);
  }
}

function* handleSendEmailW9Form({ payload }) {
  try {
    const res = yield call(sendEmailW9Form, payload);
    yield put(sendEmailW9FormSuccess(res.data));
  } catch (error) {
    yield put(sendEmailW9FormFailure());
    yield handleErrorSaga(error);
  }
}

function* handleCheckProvidedW9Form({ payload }) {
  try {
    const res = yield call(checkProvidedW9Form, payload);
    yield put(checkProvidedW9FormSuccess(res.data));
  } catch (error) {
    yield put(checkProvidedW9FormFailure());
    yield handleErrorSaga(error);
  }
}

export default function* referralPartnerSaga() {
  yield takeLatest(getReferralPartnersRequest.type, handleGetReferralPartners);
  yield takeLatest(getReferralPartnerByIdRequest, handleGetReferralPartnerById);
  yield takeLatest(updateReferralPartnerRequest, handleUpdateReferralPartner);
  yield takeLatest(
    removeReferralPartnerRequest.type,
    handleRemoveReferralPartner
  );
  yield takeLatest(
    getStatusEmailSentW9FormRequest.type,
    handlegetStatusEmailSentW9FormW9Form
  );
  yield takeLatest(sendEmailW9FormRequest.type, handleSendEmailW9Form);
  yield takeLatest(checkProvidedW9FormRequest.type, handleCheckProvidedW9Form);
}
